import { useEffect } from 'react';

export function useGlobalWindowEventHandler<K extends keyof WindowEventMap>(
  event: K,
  handler: (event: WindowEventMap[K]) => void,
  passive = false,
) {
  useEffect(() => {
    window.addEventListener(event, handler, passive);
    return () => window.removeEventListener(event, handler);
  }, [event, handler, passive]);
}

export function useGlobalDocumentEventHandler<K extends keyof DocumentEventMap>(
  event: K,
  handler: (event: DocumentEventMap[K]) => void,
  passive = false,
) {
  useEffect(() => {
    document.addEventListener(event, handler, passive);
    return () => document.removeEventListener(event, handler);
  }, [event, handler, passive]);
}
